import React from "react";

import {
  fontSize11 as counterSize,
  fontSize32 as iconSize,
  textColorPrimary as countColor,
  yellow10 as yellow,
} from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

const IconHolder = styled.span`
  font-size: ${iconSize};
  position: relative;
  display: inline-block;
  width: 2rem;
  height: 2rem;
`;
const CounterHolder = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: ${yellow};
  color: ${countColor};
  min-width: 12px;
  min-height: 12px;
  border-radius: 6px;
  font-size: ${counterSize};
  text-align: center;
`;

const CounterIcon = ({ count = 0, children, alwaysShowCount = true }) => {
  const showCount = count > 0 || alwaysShowCount;
  return (
    <IconHolder data-id="counter-icon">
      {children}
      {showCount ? (
        <CounterHolder data-id="counter-icon-number">{count}</CounterHolder>
      ) : null}
    </IconHolder>
  );
};

export default CounterIcon;
